import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

import SummaryTable from './summary-table';
import Modal from './modal';

const Versions = ({ versions, allVersions, state, currentVersion, policyType }) => {
  const [open, setOpen] = useState(false);
  const onModalClick = useCallback(() => setOpen(true), [setOpen]);
  const onClose = useCallback(() => setOpen(!open), [open, setOpen]);

  return (
    <>
      <SummaryTable versions={versions} state={state} />
      <Button variant="text" color="secondary" onClick={onModalClick}>
        See full policy change history
      </Button>
      <Modal
        state={state}
        open={open}
        versions={allVersions}
        onClose={onClose}
        currentVersion={currentVersion}
        policyType={policyType}
      />
    </>
  );
};

Versions.propTypes = {
  versions: PropTypes.array.isRequired,
  allVersions: PropTypes.array.isRequired,
  state: PropTypes.string.isRequired,
  currentVersion: PropTypes.number,
  policyType: PropTypes.string.isRequired
};

export default Versions;
